export const NETWORK_QUALITY_SCORE = {
  poor: 0,
  suboptimal: 1,
  good: 2,
  excellent: 3,
};

export const NETWORK_BITRATE_TEST_VALUES_LIMIT = 5;

const METRICS_THRESHOLD = {
  latency: {
    goodThreshold: 100,
    suboptimalThreshold: 250,
    poorThreshold: 400,
  },
  jitter: {
    goodThreshold: 5,
    suboptimalThreshold: 10,
    poorThreshold: 30,
  },
  packetLoss: {
    goodThreshold: 1,
    suboptimalThreshold: 3,
    poorThreshold: 8,
  },
  bitrate: {
    goodThreshold: 1000,
    suboptimalThreshold: 500,
    poorThreshold: 150,
  },
};

export const getQualityScore = (preflightReport, bitrateReport) => {
  let scoreArray = [
    getSingleQualityScore(preflightReport?.stats.rtt.average, METRICS_THRESHOLD.latency),
    getSingleQualityScore(preflightReport?.stats.jitter.average, METRICS_THRESHOLD.jitter),
    getSingleQualityScore(preflightReport?.stats.packetLoss.average, METRICS_THRESHOLD.packetLoss),
    getSingleQualityScore(bitrateReport?.averageBitrate, METRICS_THRESHOLD.bitrate, true),
  ];
  let avg = scoreArray.reduce((a, b) => a + b, 0) / scoreArray.length || 0;
  if (avg === 0) return 0;
  return Math.min(...scoreArray);
};

export const getSingleQualityScore = (
  stat,
  { goodThreshold, suboptimalThreshold, poorThreshold },
  descending = false
) => {
  let result;

  if (typeof stat === 'undefined') {
    return NETWORK_QUALITY_SCORE.excellent;
  }

  if (descending) {
    if (stat > poorThreshold) result = NETWORK_QUALITY_SCORE.suboptimal;
    if (stat > suboptimalThreshold) result = NETWORK_QUALITY_SCORE.good;
    if (stat > goodThreshold) result = NETWORK_QUALITY_SCORE.excellent;
    return result || NETWORK_QUALITY_SCORE.poor;
  }

  if (stat >= goodThreshold) result = NETWORK_QUALITY_SCORE.good;
  if (stat >= suboptimalThreshold) result = NETWORK_QUALITY_SCORE.suboptimal;
  if (stat >= poorThreshold) result = NETWORK_QUALITY_SCORE.poor;
  return result || NETWORK_QUALITY_SCORE.excellent;
};
